import React, { useState } from 'react';
import './feedbackListForAdmin.scss'
import { Button, Modal } from 'react-bootstrap';
import PrimaryButton from '../../jsx/components/button/primaryButton';
import { lblOperatingSystemDetails, lblPlatform, txtCreatedOn, txtEmail, txtFeedbackDetails, txtName, txtPhoneNumber, txtPhotos, txtRoute, txtSentMessage } from '../../dataBaseFile/label';



const FeedbackDetailsForAdmin = ({
    feedbackDetailsTrigger,
    handleCloseFeedbackDetails,
    data,
    time,
    phoneNumber }) => {


    const [openDoc, setOpenDoc] = useState(false);
    const [imageAttach, setImageAttach] = useState(1);
    const [proAvailableFlag, setProAvailableFlag] = useState(0)

    const handleOpenDoc = () => {
        setOpenDoc(true);
    }
    const handleCloseDoc = () => setOpenDoc(false);



    return (
        <>
            {/* <!-- Modal --> */}
            <Modal className="fade" show={feedbackDetailsTrigger}
            // onHide={handleCloseFeedbackDetails}
            >
                <Modal.Header style={{ borderBottom: 'none' }}>
                    <Modal.Title>{txtFeedbackDetails}</Modal.Title>
                    {/* <PrimaryButton
                        buttonName={"Close"} onClick={handleCloseFeedbackDetails} /> */}

                    <Button
                        variant=""
                        className="btn-close btn-close-service"
                        onClick={() => handleCloseFeedbackDetails()}
                    ></Button>
                </Modal.Header>

                <Modal.Body>


                    <div className='callDetailsRows'>
                        <p className='call-titles' >{txtName}</p>
                        <p className='call-sub-titles'>{data?.full_name_chr == null || data?.full_name_chr == "" ? "NA" : data?.full_name_chr}</p>
                    </div>

                    <div className='callDetailsRows'>
                        <p className='call-titles' >{txtEmail}</p>
                        <p className='call-sub-titles'>{data?.email_chr == null || data?.email_chr == "" ? "NA" : data?.email_chr}</p>
                    </div>

                    <div className='callDetailsRows'>
                        <p className='call-titles' >{txtPhoneNumber}</p>
                        <p className='call-sub-titles'>
                            {phoneNumber}
                        </p>
                    </div>



                    <div className='callDetailsRows'>
                        <p className='call-titles'>{txtCreatedOn}</p>
                        <p className='call-sub-titles'>
                            {new Intl.DateTimeFormat("en-US", {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                            }).format(time)}
                        </p>
                    </div>

                    <div className='callDetailsRows'>
                        <p className='call-titles'>{lblOperatingSystemDetails}</p>
                        <p className='call-sub-titles'>{data?.operating_system_details_chr}</p>
                    </div>

                    <div className='callDetailsRows'>
                        <p className='call-titles'>{txtRoute}</p>
                        <p className='call-sub-titles'>{data?.page_details_chr}</p>
                    </div>

                    <div className='callDetailsRows'>
                        <p className='call-titles'>{lblPlatform}</p>
                        <p className='call-sub-titles'>{data?.platform_chr}</p>
                    </div>

                    <div className='callDetailsRows'>
                        <p className='call-titles'> {txtSentMessage}</p>
                        <p className='call-sub-titles'>{data?.feedback_message_chr}</p>
                    </div>

                    <div className='d-flex photos-section'>
                        <div className='photos-section-title'>{txtPhotos}</div>
                        <div className='attached-img-container'>
                            <div className='attached-img-individual-box' onClick={() => { handleOpenDoc() }}>
                                <img src={data.url} alt="Error Loading" className='serviceImg' />
                            </div>
                        </div>
                    </div>





                </Modal.Body>
            </Modal>

            {/* Modal for previewing the attached image preview */}
            <>

                <Modal show={openDoc} onHide={handleCloseDoc} style={{ background: '#fff0', border: 'none', }}>

                    <div className='image-preview-modal-header'>

                        <a href={data.url} target="_blank" rel="noreferrer">
                            <i style={{ fontSize: '20px', marginLeft: '20px' }} className="bi bi-download image-preview-modal-action-btn" />
                        </a>

                        <div onClick={handleCloseDoc} className='image-preview-modal-action-btn-close'>
                            <i style={{ fontSize: '30px', }} className="bi bi-x"></i>
                        </div>

                    </div>

                    <>
                        <img src={data.url} alt='Error Loading' style={{ width: '100%', height: '100%' }} />
                    </>

                </Modal>
            </>
        </>
    )
}

export default FeedbackDetailsForAdmin